var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-dialog',{attrs:{"title":"企胜力服务协议和条款","visible":_vm.clause,"width":"580px","height":"460px","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.clause=$event}}},[_c('div',{staticStyle:{"height":"400px","overflow":"auto"},domProps:{"innerHTML":_vm._s(_vm.detail)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-5b19f434","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/Clause.vue
// module id = null
// module chunks = 